<template>
  <article class="kpi-card">
    <div class="kpi-icon" :style="iconStyle">
      <i class="fa" :class="icon" aria-hidden="true"></i>
    </div>

    <div class="kpi-copy">
      <p>{{ title }}</p>
      <div class="kpi-values">
        <h3>
          <span class="kpi-value-text">{{ value }}</span>
        </h3>
        <small v-if="meta" class="kpi-value-meta">{{ meta }}</small>
      </div>
    </div>
  </article>
</template>

<script>
export default {
  name: 'SimpleNotesKpiCard',
  props: {
    title: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
    meta: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: 'fa-sticky-note-o',
    },
    iconBg: {
      type: String,
      default: '#eaf7ef',
    },
    iconColor: {
      type: String,
      default: '#2f855a',
    },
  },
  computed: {
    iconStyle() {
      return {
        background: this.iconBg,
        color: this.iconColor,
      };
    },
  },
};
</script>

<style scoped>
.kpi-card {
  background: #fff;
  border: 1px solid rgba(153, 152, 153, 0.2);
  border-radius: 9px;
  box-shadow: 0 3px 12px rgba(0, 98, 163, 0.08);
  padding: 14px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.kpi-icon {
  width: 40px;
  height: 40px;
  border-radius: 7.5px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  flex-shrink: 0;
}

.kpi-copy {
  flex: 1;
  min-width: 0;
}

.kpi-copy p {
  margin: 0;
  font-size: 11px;
  color: #999899;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.kpi-values {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  width: 100%;
  min-width: 0;
}

.kpi-values h3 {
  margin: 2px 0 0;
  font-size: 24px;
  color: #494949;
  font-weight: 700;
  line-height: 1.2;
  width: 100%;
  min-width: 0;
}

.kpi-value-text {
  display: inline-block;
  max-width: 100%;
}

.kpi-value-meta {
  font-size: 11px;
  color: #6b7280;
  line-height: 1.2;
}
</style>
